import { render } from "./BaseFilterTab.vue?vue&type=template&id=754ea87f"
import script from "./BaseFilterTab.vue?vue&type=script&lang=js"
export * from "./BaseFilterTab.vue?vue&type=script&lang=js"

import "./BaseFilterTab.vue?vue&type=style&index=0&id=754ea87f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__